var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPizzaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE841A"
    },
    d: "M147.147,29.165l14.708,25.48l188.306,0.008l14.693-25.445 C295.082-11.081,212.277-8.353,147.147,29.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE841A"
    },
    d: "M114.018,48.332C44.242,88.614,5.202,161.689,5.128,236.852l29.46,0.001l94.136-163.047 L114.018,48.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE841A"
    },
    d: "M34.587,275.128l-29.423-0.001C5.16,355.696,48.926,426.043,113.982,463.688l14.726-25.504 L34.587,275.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE841A"
    },
    d: "M350.145,457.356l-188.306-0.008l-14.693,25.445c69.773,40.287,152.578,37.559,217.707,0.042 L350.145,457.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE841A"
    },
    d: "M477.413,275.146l-94.136,163.047l14.705,25.474c69.776-40.28,108.816-113.357,108.889-188.52 L477.413,275.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE841A"
    },
    d: "M398.019,48.312l-14.728,25.504l94.122,163.055l29.423,0.001 C506.84,156.305,463.075,85.957,398.019,48.312z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE368"
    },
    d: "M350.162,54.651C321.569,41.257,289.663,33.758,256,33.758c-33.656,0-65.556,7.495-94.145,20.885 L256,217.725L350.162,54.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE368"
    },
    d: "M128.724,73.806c-52.5,36.744-88.378,95.593-94.135,163.047l188.265,0.009L128.724,73.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE368"
    },
    d: "M34.587,275.128c5.751,67.455,41.625,126.308,94.121,163.055l94.145-163.046L34.587,275.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE368"
    },
    d: "M161.838,457.349c28.593,13.394,60.499,20.893,94.162,20.893c33.656,0,65.556-7.495,94.145-20.885 L256,294.275L161.838,457.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE368"
    },
    d: "M477.413,275.146l-188.265-0.009l94.129,163.056C435.776,401.449,471.655,342.6,477.413,275.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE368"
    },
    d: "M477.414,236.871c-5.751-67.455-41.625-126.308-94.122-163.055l-94.145,163.046L477.414,236.871z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD4A38"
    },
    cx: 256,
    cy: 140.018,
    r: 8.438
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD4A38"
    },
    cx: 73.436,
    cy: 206.724,
    r: 8.438
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD4A38"
    },
    cx: 147.141,
    cy: 205.599,
    r: 8.438
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD4A38"
    },
    cx: 160.082,
    cy: 324.371,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD4A38"
    },
    cx: 250.937,
    cy: 363.542,
    r: 8.438
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD4A38"
    },
    cx: 350.175,
    cy: 311.555,
    r: 8.438
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD4A38"
    },
    cx: 390.021,
    cy: 388.861,
    r: 8.438
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AD4A38"
    },
    cx: 390.021,
    cy: 122.441,
    r: 8.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F63E31"
    },
    cx: 256,
    cy: 88.322,
    r: 20.572
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F63E31"
    },
    cx: 110.784,
    cy: 172.155,
    r: 20.572
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F63E31"
    },
    cx: 110.784,
    cy: 339.844,
    r: 20.572
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F63E31"
    },
    cx: 256,
    cy: 423.677,
    r: 20.572
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F63E31"
    },
    cx: 401.217,
    cy: 339.844,
    r: 20.572
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F63E31"
    },
    cx: 401.217,
    cy: 172.155,
    r: 20.572
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaLogo);
export default __webpack_public_path__ + "static/media/pizza-logo.4459e63c7c396f5c8e606b1d8794ac23.svg";
export { ForwardRef as ReactComponent };